import { useEffect, useState } from 'react';
import { ProductCardProduct } from 'shared/types/product/Product';
import { useProduct } from 'frontastic/hooks';
import ProductRecommendationGrid from './ProductRecommendationGrid';
import useRecentlyViewed from '../hooks/useRecentlyViewed';

interface Props {
  sku: string;
}

const ProductRecentlyViewedSection = ({ sku }: Props) => {
  const { addProduct, recentlyViewed } = useRecentlyViewed();
  const { queryRecentlyViewedProduct } = useProduct();

  // This flag ensures the Action API is triggered only once after the new product is added and the SKUs array is updated.
  // Without this flag, the Action API would be triggered twice: once for the initial SKUs and again for the updated SKUs.
  const [isNewProductAdded, setIsNewProductAdded] = useState<boolean>(false);
  const [productsRecentlyViewed, setProductsRecentlyViewed] = useState<ProductCardProduct[]>([]);

  useEffect(() => {
    if (sku) {
      addProduct(sku);
      setIsNewProductAdded(true);
    }
  }, []);

  useEffect(() => {
    async function getRecentViewedProducts() {
      const products = await Promise.all(
        recentlyViewed.map(
          async (sku) =>
            await queryRecentlyViewedProduct(sku).then((res) => {
              if (!res.isError) {
                return res.data;
              }
              return undefined;
            }),
        ),
      );

      const recentlyProducts = products.filter((product) => product !== undefined);
      setProductsRecentlyViewed(recentlyProducts);
    }
    if (isNewProductAdded) {
      getRecentViewedProducts();
    }
  }, [isNewProductAdded]);

  if (productsRecentlyViewed.length < 1) return null;

  return (
    <ProductRecommendationGrid
      title="Recently Viewed"
      products={productsRecentlyViewed}
      location="Recently Viewed"
      maxItems={4}
      sectionId="recently-viewed-carousel"
    />
  );
};

export default ProductRecentlyViewedSection;
